import { Link } from "react-router-dom";
import Obsessionslogo from "../../assets/images/logo-dark.png";
const PageServerError = () => {
    const linkStyle = {
        fontFamily: "verdana,arial,helvetica,sans-serif",
        color: "#004B91",
    };

    const containerStyle = {
        fontFamily: "verdana,arial,helvetica,sans-serif",
        backgroundColor: "#FFFFFF",
        color: "#000000",
        textAlign: "center",
    };

    return (
        <div style={containerStyle} className="mt-4">
            <Link
                to="/"
                state={{ ref: "404_logo" }}
            >
                <img src={Obsessionslogo} alt="Obsessions Logo" width={150} />
            </Link>
            <table border="0" align="center" style={{ marginTop: "20px" }}>
                <table border="0" align="center" style={{ marginTop: "20px" }}>
                    <tbody>
                        <tr>
                            <td style={{ textAlign: "center" }}>
                                <b style={{ color: "#e44211", fontSize: "18px" }}>
                                    Something went wrong
                                </b>
                                <br />
                                <br />
                                We're unable to connect to the server right now or the service is temporarily unavailable.
                                <br />
                                Please try again in a few moments.
                                <br />
                                <br />
                                <b>
                                    <a href="/" style={linkStyle}>
                                        Go back to the Obsessions homepage
                                    </a>
                                </b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </table>
        </div>
    );
};

export default PageServerError;